// Copyright (c) Ergoss Logiciels - All rights reserved - Proprietary and confidential
import type { Routes } from '@angular/router';
import { MainComponent } from '@core/layout/main.component';

export const routes: Routes = [
  // Replay opens in its own tab as a full-screen routed page, outside the
  // MainComponent shell (no nav chrome). Lazy-loaded via the feature module.
  {
    path: 'replay',
    loadChildren: () => import('@features/replay/replay.routes').then((m) => m.REPLAY_ROUTES),
  },
  // Sample-flights replay — same shape (full-screen, outside the shell) but
  // backed by the pedagogical sample API instead of a real movement log.
  {
    path: 'sample-flights',
    loadChildren: () => import('@features/sample-flights/sample-flights.routes').then((m) => m.SAMPLE_FLIGHTS_ROUTES),
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('@features/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'flights',
        loadChildren: () => import('@features/flights/flights.routes').then((m) => m.FLIGHTS_ROUTES),
      },
      {
        path: 'briefing',
        loadChildren: () => import('@features/briefing/briefing.routes').then((m) => m.BRIEFING_ROUTES),
      },
      {
        path: 'reports',
        loadChildren: () => import('@features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
      },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      // Catch-all for unknown routes — rendered inside the shell so the user
      // keeps the nav and a way back, rather than hitting a blank dead end.
      {
        path: '**',
        loadComponent: () => import('@features/not-found/pages/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
